import React from "react";

// TP-Friendlies pill family. Tokens are verbatim from DESIGN-INVENTORY §4.2 so
// every card (desktop + mobile) renders identically. Small building blocks so the
// composer preview (M3) reuses them unchanged.

// Location-mode → { label, bg, fg, dot } (design MODES table + CAMP).
export const LOCATION_MODE_META = {
  host: { label: "HOSTING", bg: "#E7F6EF", fg: "#0E7B52", dot: "#17B26A" },
  travel: { label: "WE TRAVEL", bg: "#FFF4E6", fg: "#B25409", dot: "#F79009" },
  neutral: { label: "NEUTRAL VENUE", bg: "#EEF1F6", fg: "#475467", dot: "#98A2B3" },
  camp: { label: "TRAINING CAMP", bg: "#F4F0FF", fg: "#6941C6", dot: "#9B8AFB" },
};

// Team-category pill (structured category — powers filters; the free-text label is
// rendered separately by the card).
export const TeamCategoryPill = ({ label }) => {
  if (!label) return null;
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-[11.5px] font-semibold whitespace-nowrap"
      style={{ backgroundColor: "#F0F3F7", color: "#3D4C63" }}
    >
      {label}
    </span>
  );
};

// Location-mode pill with a leading dot. Camp appends its DESTINATION
// ("TRAINING CAMP · Belek, Türkiye") — the binding under-destination rule.
export const LocationModePill = ({ location }) => {
  const mode = location?.mode || "host";
  const meta = LOCATION_MODE_META[mode] || LOCATION_MODE_META.host;
  let detail = "";
  if (mode === "camp") {
    detail = [location?.region, location?.country?.name].filter(Boolean).join(", ");
  }
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-[0.02em] whitespace-nowrap"
      style={{ backgroundColor: meta.bg, color: meta.fg }}
    >
      <span className="w-[5px] h-[5px] rounded-full flex-shrink-0" style={{ backgroundColor: meta.dot }} />
      {meta.label}
      {detail && <span className="font-medium normal-case tracking-normal">· {detail}</span>}
    </span>
  );
};

// Compact opponent-tier line ("Opponent: Tier 1–2" / "Tier 3 or lower" / "Any
// level") — the server-formatted display string, never a parallel vocabulary.
export const OpponentTierLine = ({ display }) => {
  if (!display) return null;
  return (
    <span className="text-[12px] text-[#475467] whitespace-nowrap">
      Opponent: <span className="font-semibold text-[#33475E]">{display}</span>
    </span>
  );
};

// FLEXIBLE / CAMP date-rail badges + the MULTIPLE MATCHES flag.
export const FlexibleBadge = () => (
  <span
    className="inline-flex items-center rounded-[6px] px-1.5 py-0.5 text-[9.5px] font-bold uppercase tracking-[0.06em]"
    style={{ backgroundColor: "#EAF3FF", color: "#1866CC" }}
  >
    Flexible
  </span>
);

export const CampBadge = () => (
  <span
    className="inline-flex items-center rounded-[6px] px-1.5 py-0.5 text-[9.5px] font-bold uppercase tracking-[0.06em]"
    style={{ backgroundColor: "#F4F0FF", color: "#6941C6" }}
  >
    Camp
  </span>
);

export const MultipleMatchesBadge = () => (
  <span
    className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.04em] whitespace-nowrap"
    style={{ backgroundColor: "#EAF3FF", color: "#1866CC" }}
  >
    Multiple matches
  </span>
);

const FriendlyPills = {
  TeamCategoryPill,
  LocationModePill,
  OpponentTierLine,
  FlexibleBadge,
  CampBadge,
  MultipleMatchesBadge,
  LOCATION_MODE_META,
};

export default FriendlyPills;
